import { CONSTANTS } from '../data';

export class EffectsSystem {
  public createSpiralAnimation() {
    const fusionCircle = document.getElementById('fusion-circle');
    if (!fusionCircle) return;

    const spiral = document.createElement('div');
    spiral.className = 'spiral-effect';
    
    const rect = fusionCircle.getBoundingClientRect();
    const centerX = rect.width / 2 - CONSTANTS.SPIRAL_EFFECT.size / 2;
    const centerY = rect.height / 2 - CONSTANTS.SPIRAL_EFFECT.size / 2;
    
    spiral.style.left = centerX + 'px';
    spiral.style.top = centerY + 'px';
    
    fusionCircle.appendChild(spiral);
    
    setTimeout(() => {
      if (spiral.parentNode) {
        spiral.remove();
      }
    }, CONSTANTS.SPIRAL_EFFECT.durationMs);
  }

  public animateElementsToCenter(elementNames: string[]) {
    const fusionCircle = document.getElementById('fusion-circle');
    if (!fusionCircle || elementNames.length !== 2) return;

    const elem1 = fusionCircle.querySelector(`[data-fused-element="${elementNames[0]}"]`) as HTMLElement;
    const elem2 = fusionCircle.querySelector(`[data-fused-element="${elementNames[1]}"]`) as HTMLElement;

    if (!elem1 || !elem2) return;

    const rect1 = elem1.getBoundingClientRect();
    const rect2 = elem2.getBoundingClientRect();
    const circleRect = fusionCircle.getBoundingClientRect();

    elem1.style.position = 'absolute';
    elem1.style.left = `${rect1.left - circleRect.left}px`;
    elem1.style.top = `${rect1.top - circleRect.top}px`;

    elem2.style.position = 'absolute';
    elem2.style.left = `${rect2.left - circleRect.left}px`;
    elem2.style.top = `${rect2.top - circleRect.top}px`;

    const duration = CONSTANTS.COMBINE_EFFECT.elementAnimationDurationMs / 1000;
    elem1.style.transition = `all ${duration}s ease-in`;
    elem2.style.transition = `all ${duration}s ease-in`;

    requestAnimationFrame(() => {
      const centerX = fusionCircle.offsetWidth / 2 - elem1.offsetWidth / 2;
      const centerY = fusionCircle.offsetHeight / 2 - elem1.offsetHeight / 2;

      elem1.style.left = `${centerX}px`;
      elem1.style.top = `${centerY}px`;
      elem1.style.transform = 'scale(0)';
      elem1.style.opacity = '0';

      elem2.style.left = `${centerX}px`;
      elem2.style.top = `${centerY}px`;
      elem2.style.transform = 'scale(0)';
      elem2.style.opacity = '0';
    });
  }

  public triggerRefusalAnimation() {
    const fusionCircle = document.getElementById('fusion-circle');
    if (!fusionCircle) return;

    fusionCircle.classList.add('ai-refusal', 'ai-refusal-shake');
    
    setTimeout(() => {
      fusionCircle.classList.remove('ai-refusal', 'ai-refusal-shake');
    }, CONSTANTS.AI_REFUSAL.animationDurationMs);
  }

  public createChainEffect(elementName: string) {
    setTimeout(() => {
      const elementNode = document.querySelector(`[data-element="${elementName}"]`) as HTMLElement;
      if (elementNode) {
        elementNode.classList.add('chain-reaction-effect');
        setTimeout(() => {
          elementNode.classList.remove('chain-reaction-effect');
        }, CONSTANTS.CHAIN_REACTION_EFFECT.durationMs);
      }
    }, 100);
  }

  public triggerCombineEffects() {
    const circle = document.getElementById('fusion-circle');
    if (!circle) return;

    circle.classList.add('combining');
    const combiningDuration = CONSTANTS.COMBINE_EFFECT.combiningAnimationDuration;
    setTimeout(() => {
      circle.classList.remove('combining');
    }, combiningDuration);

    const flash = document.createElement('div');
    flash.className = 'flash-effect';
    const flashDuration = CONSTANTS.COMBINE_EFFECT.flashDurationMs;
    flash.style.animationDuration = `${flashDuration}ms`;
    circle.appendChild(flash);
    setTimeout(() => {
      flash.remove();
    }, flashDuration);

    const count = CONSTANTS.COMBINE_EFFECT.particleCount;
    const range = CONSTANTS.COMBINE_EFFECT.particleRangePx;
    const particleLifetime = CONSTANTS.COMBINE_EFFECT.particleDurationMs;

    for (let i = 0; i < count; i++) {
      const p = document.createElement('div');
      p.className = 'particle';
      p.style.left = 'calc(50% - 2px)';
      p.style.top = 'calc(50% - 2px)';

      const dx = (Math.random() * 2 - 1) * range;
      const dy = (Math.random() * 2 - 1) * range;
      p.style.setProperty('--tx', `${dx}px`);
      p.style.setProperty('--ty', `${dy}px`);

      p.style.animationDuration = `${particleLifetime}ms`;

      p.addEventListener('animationend', () => {
        p.remove();
      });

      circle.appendChild(p);
    }

    this.createSpiralAnimation();
  }

  public createAIDiscoveryEffect() {
    const aiPanel = document.getElementById('ai-mind-panel');
    if (aiPanel) {
      aiPanel.classList.add('ai-discovery-effect');
      setTimeout(() => {
        aiPanel.classList.remove('ai-discovery-effect');
      }, CONSTANTS.AI_CREATION.effectDurationMs);
    }
  }
}
